const pageNameKey = "otaDrawerForm";

export const otaDrawerFormEn = {
  [pageNameKey]: {
    firmwareVersionText: "Firmware Version",
    versionPlaceholderText: "Choose precise name",

    firmwareNameText: "Firmware Name",
    namePlaceholderText: "Choose precise name",

    configurationVersionText: "Configuration Version",
    configurationNameText: "Configuration Name",

    releaseNotesText: "Release Notes",
    releaseNotesPlaceholderText:
      "What are the details operators need to know, before they install this firmware? What are the highlights?",

    improvmentsText: "Improvements",
    improvmentsPlaceholderText:
      "What are the details operators need to know, before they install this firmware? What are the highlights?",

    generalText: "General",
    generalPlaceholderText:
      "What are the details operators need to know, before they install this firmware? What are the highlights?",

    fixesText: "Fixes",
    fixesPlaceholderText:
      "What are the details operators need to know, before they install this firmware? What are the highlights?",

    uploadFileText: "Upload File",
  },
};

export const otaDrawerFormPtBr = {
  [pageNameKey]: {
    firmwareVersionText: "Versão do firmware",
    versionPlaceholderText: "Escolha um nome preciso",

    firmwareNameText: "Nome do firmware",
    namePlaceholderText: "Escolha um nome preciso",

    configurationVersionText: "Versão da configuração",
    configurationNameText: "Nome da configuração",

    releaseNotesText: "Notas da versão",
    releaseNotesPlaceholderText:
      "Quais são os detalhes que os operadores precisam saber antes de instalar este firmware? Quais são os destaques?",

    improvmentsText: "Melhorias",
    improvmentsPlaceholderText:
      "Quais são os detalhes que os operadores precisam saber antes de instalar este firmware? Quais são os destaques?",

    generalText: "Geral",
    generalPlaceholderText:
      "Quais são os detalhes que os operadores precisam saber antes de instalar este firmware? Quais são os destaques?",

    fixesText: "Correções",
    fixesPlaceholderText:
      "Quais são os detalhes que os operadores precisam saber antes de instalar este firmware? Quais são os destaques?",

    uploadFileText: "Enviar arquivo",
  },
};

export const otaDrawerFormDe = {
  [pageNameKey]: {
    firmwareVersionText: "Firmware-Version",
    versionPlaceholderText: "Wählen Sie einen genauen Namen",

    firmwareNameText: "Firmware-Name",
    namePlaceholderText: "Wählen Sie einen genauen Namen",

    configurationVersionText: "Konfigurationsversion",
    configurationNameText: "Konfigurationsname",

    releaseNotesText: "Versionshinweise",
    releaseNotesPlaceholderText:
      "Welche Details müssen Betreiber vor der Installation dieser Firmware wissen? Was sind die wichtigsten Neuerungen?",

    improvmentsText: "Verbesserungen",
    improvmentsPlaceholderText:
      "Welche Details müssen Betreiber vor der Installation dieser Firmware wissen? Was sind die wichtigsten Neuerungen?",

    generalText: "Allgemein",
    generalPlaceholderText:
      "Welche Details müssen Betreiber vor der Installation dieser Firmware wissen? Was sind die wichtigsten Neuerungen?",

    fixesText: "Korrekturen",
    fixesPlaceholderText:
      "Welche Details müssen Betreiber vor der Installation dieser Firmware wissen? Was sind die wichtigsten Neuerungen?",

    uploadFileText: "FixesUpload-Datei",
  },
};

export const otaDrawerFormZhHans = {
  [pageNameKey]: {
    firmwareVersionText: "固件版本",
    versionPlaceholderText: "选择准确的名称",

    firmwareNameText: "固件名称",
    namePlaceholderText: "选择准确的名称",

    configurationVersionText: "配置版本",
    configurationNameText: "配置名称",

    releaseNotesText: "发行说明",
    releaseNotesPlaceholderText:
      "运营商在安装此固件之前需要了解哪些细节？主要亮点是什么？",

    improvmentsText: "改进",
    improvmentsPlaceholderText:
      "运营商在安装此固件之前需要了解哪些细节？主要亮点是什么？",

    generalText: "一般的",
    generalPlaceholderText:
      "运营商在安装此固件之前需要了解哪些细节？主要亮点是什么？",

    fixesText: "一般修复",
    fixesPlaceholderText:
      "运营商在安装此固件之前需要了解哪些细节？主要亮点是什么？",

    uploadFileText: "上传文件",
  },
};

export const otaDrawerFormIt = {
  [pageNameKey]: {
    firmwareVersionText: "Versione del firmware",
    versionPlaceholderText: "Scegli un nome",

    firmwareNameText: "Nome firmware",
    namePlaceholderText: "Scegli un nome",

    configurationVersionText: "Versione della configurazione",
    configurationNameText: "Nome configurazione",

    releaseNotesText: "Note di rilascio",
    releaseNotesPlaceholderText:
      "In merito alle note di rilascio, quali sono i dettagli importanti che gli operatori devono conoscere, prima di installare questo firmware? Quali sono le principali caratteristiche?",

    improvmentsText: "Miglioramenti",
    improvmentsPlaceholderText:
      "In merito ai miglioramenti, quali sono i dettagli importanti che gli operatori devono conoscere, prima di installare questo firmware? Quali sono le principali caratteristiche?",

    generalText: "Generale",
    generalPlaceholderText:
      "In merito alle informazioni generali, quali sono i dettagli importanti che gli operatori devono conoscere, prima di installare questo firmware? Quali sono le principali caratteristiche?",

    fixesText: "Correzioni",
    fixesPlaceholderText:
      "In merito alle correzioni, quali sono i dettagli importanti che gli operatori devono conoscere, prima di installare questo firmware? Quali sono le principali caratteristiche?",

    uploadFileText: "Carica File",
  },
};

export const otaDrawerFormEs = {
  [pageNameKey]: {
    firmwareVersionText: "Versión del firmware",
    versionPlaceholderText: "Elige un nombre preciso",

    firmwareNameText: "Nombre del firmware",
    namePlaceholderText: "Elige un nombre preciso",

    configurationVersionText: "Versión de configuración",
    configurationNameText: "Nombre de la configuración",

    releaseNotesText: "Notas de la versión",
    releaseNotesPlaceholderText:
      "¿Qué detalles deben conocer los operadores antes de instalar este firmware? ¿Cuáles son los aspectos más destacados?",

    improvmentsText: "Mejoras",
    improvmentsPlaceholderText:
      "¿Qué detalles deben conocer los operadores antes de instalar este firmware? ¿Cuáles son los aspectos más destacados?",

    generalText: "General",
    generalPlaceholderText:
      "¿Qué detalles deben conocer los operadores antes de instalar este firmware? ¿Cuáles son los aspectos más destacados?",

    fixesText: "Correcciones",
    fixesPlaceholderText:
      "¿Qué detalles deben conocer los operadores antes de instalar este firmware? ¿Cuáles son los aspectos más destacados?",

    uploadFileText: "Subir archivo",
  },
};

export const otaDrawerFormNl = {
  [pageNameKey]: {
    configurationNameText: "Configuratienaam",
    configurationVersionText: "Configuratieversie",
    firmwareNameText: "Firmwarenaam",
    firmwareVersionText: "Firmware-versie",
    fixesPlaceholderText:
      "Welke details moeten operators weten voordat ze deze firmware installeren? Wat zijn de belangrijkste punten?",
    fixesText: "Foutoplossingen",
    generalPlaceholderText:
      "Welke details moeten operators weten voordat ze deze firmware installeren? Wat zijn de belangrijkste punten?",
    generalText: "Algemeen",
    improvmentsPlaceholderText:
      "Welke details moeten operators weten voordat ze deze firmware installeren? Wat zijn de belangrijkste punten?",
    improvmentsText: "Verbeteringen",
    namePlaceholderText: "Kies een duidelijke naam",
    releaseNotesPlaceholderText:
      "Welke details moeten operators weten voordat ze deze firmware installeren? Wat zijn de belangrijkste punten?",
    releaseNotesText: "Release-opmerkingen",
    uploadFileText: "Bestand uploaden",
    versionPlaceholderText: "Kies een duidelijke naam",
  },
};

export const otaDrawerFormTr = {
  [pageNameKey]: {
    configurationNameText: "Yapılandırma Adı",
    configurationVersionText: "Yapılandırma Sürümü",
    firmwareNameText: "Firmware Adı",
    firmwareVersionText: "Donanım Yazılımı Sürümü",
    fixesPlaceholderText:
      "Bu ürün yazılımını yüklemeden önce operatörlerin bilmesi gereken ayrıntılar nelerdir? Öne çıkanlar nelerdir?",
    fixesText: "Düzeltmeler",
    generalPlaceholderText:
      "Bu ürün yazılımını yüklemeden önce operatörlerin bilmesi gereken ayrıntılar nelerdir? Öne çıkanlar nelerdir?",
    generalText: "Genel",
    improvmentsPlaceholderText:
      "Bu ürün yazılımını yüklemeden önce operatörlerin bilmesi gereken ayrıntılar nelerdir? Öne çıkanlar nelerdir?",
    improvmentsText: "İyileştirmeler",
    namePlaceholderText: "Tam adı seçin",
    releaseNotesPlaceholderText:
      "Bu ürün yazılımını yüklemeden önce operatörlerin bilmesi gereken ayrıntılar nelerdir? Öne çıkanlar nelerdir?",
    releaseNotesText: "Sürüm Notları",
    uploadFileText: "Dosya Yükle",
    versionPlaceholderText: "Tam adı seçin",
  },
};
